module.exports = __webpack_public_path__ + "img/spotify.977b3a3c.svg";